import region from "../utils/region.js";

import {
  BURYATIA,
  CHECHNYA,
  CHUVA,
  CRIMEA,
  HMAO,
  KALUG,
  KARELIA,
  KRASNODAR,
  KURGAN,
  KURSK,
  LITVA,
  MARIEL,
  ORENB,
  ORLOV,
  PRIMOR,
  PSCOV,
  SAAS,
  SAHALIN,
  SVERD,
  TATAR,
  VOLGOGRAD,
  YANAO,
  LEN,
  TAMBOV,
  TULA,
  CHUKOTKA,
  KAMCHATKA
}                   from '@/config/region';
import { APP_NAME } from "./common-config";

export const USER_DATA = "USER_DATA";

let _DEFAULT_REDIRECT = {
  default: {
    default: { path: "/login" },
    guest: { path: "/login" },
    user: { name: "geo.objects" }
  },
  [KALUG]: {
    default: { path: "/login" },
    guest: { path: "/login" },
    user: { name: "normative" }
  }
};

export const DEFAULT_REDIRECT = region.getRegionConfig(_DEFAULT_REDIRECT);

export const HIDDEN_ROUTES_FOR_REGISTERED = [
  "auth.login",
  "auth.requestResetPassword"
];

export const WALL = {
  SUCCESS_TIMEOUT: 2500,
  ERROR_TIMEOUT: 20000
};

export const NOTIFY = {
  SUCCESS_TIMEOUT: 2500,
  ERROR_TIMEOUT: 20000,
  NOTIFY_TIMEOUT: 6000
};

export const HTTP_TIMEOUT = 0;

export const REGION_ROOT_API = {
/*  [BURYATIA]: "http://buryatya.tko.etton.ru/api/v1/",
  [CHECHNYA]: "http://chechnya.master-tko.etton.ru/api/v1/",
  [CHUVA]: "http://ecology/api/v1/",
  [CRIMEA]: "http://ecology/api/v1/",
  [HMAO]: "http://demo-tko.etton.ru/api/v1/",
  [KALUG]: "http://kaluga.tko.etton.ru/api/v1/",
  [KARELIA]: "http://ecology/api/v1/",
  [KRASNODAR]: "http://krasnodar.tko.etton.ru/api/v1/",
  [KURGAN]: "http://kurgan-tko.etton.ru/api/v1/",
  [KURSK]: "http://ecology/api/v1/",
  [MARIEL]: "http://ecology/api/v1/",
  [ORENB]: "http://orenburg.tko.etton.ru/api/v1/",
  [ORLOV]: "http://orel.tko.etton.ru/api/v1/",
  [PRIMOR]: "http://ecology/api/v1/",
  [PSCOV]: "http://pscov.master-tko.etton.ru/api/v1/",
  [SAAS]: "https://pp1039.ru/api/v1/",
  [SAHALIN]: "https://sahalin-tko.etton.ru/api/v1/",
  [SVERD]: "http://ekb.master-tko.etton.ru/api/v1/",
  [TATAR]: "http://tatarstan.etton.ru/api/v1/",
  [VOLGOGRAD]: "http://ecology/api/v1/",
  [YANAO]: "http://yanao.master-tko.etton.ru/api/v1/",
  [LEN]: "http://ecology/api/v1/",*/
  default: "http://ecology/api/v1/",
};


export const THREADS_CONFIG = region.getRegionConfig({
  default : {
    fieldTkoObjectTitle: 'Объект ТКО',
  },
  [TAMBOV]: {
    fieldTkoObjectTitle: 'Объект обращения с отходами',
  }
});

/**
 * минимальная длина пароля пользователя в профиле
 */
export const PROFILE_PASSWORD_MINLEN = {
  default: 8,
  [KURSK]: 12
};

let _ROOT_API = {
  default: (function() {
    let storageValue = window.localStorage.getItem("ROOT_API") ? JSON.parse(window.localStorage.getItem("ROOT_API")) : null;
    if (storageValue) {
      return storageValue;
    }

    console.log("process.env.NODE_ENV=" + process.env.NODE_ENV);
    if (process.env.NODE_ENV === "production") {
      let domain = window.location.origin;
      return `${domain}/api/v1/`;
    }
    if (process.env.API_URL) {
      return { default: process.env.API_URL };
    }
    return region.getRegionConfig(REGION_ROOT_API);
  }())
};

export const ROOT_DOMAIN = (function() {
  return region.getRegionConfig(_ROOT_API).replace("api/v1/", "");
}());

export const ROOT_API = region.getRegionConfig(_ROOT_API);

let _ROOT_MONGO_API = {
  default: (function() {
    let storageValue = window.localStorage.getItem("ROOT_MONGO_API") ? JSON.parse(window.localStorage.getItem("ROOT_MONGO_API")) : null;
    if (storageValue) {
      return storageValue;
    }

    return process.env.NODE_ENV === "production"
      ? ROOT_API.toString().replace("/api/v1/", "/mongo/v1/")
      : `http://localhost:3000/mongo/v1/`;
  }())
};

export const YANDEX_API = "https://api-maps.yandex.ru/2.1/?lang=ru_RU&amp;apikey=4affa842-deeb-40c4-888e-465ce3df24b9&l=sat";

export const ROOT_MONGO_API = region.getRegionConfig(_ROOT_MONGO_API);

export const DADATA_TOKEN = "9cdaaf395c79abe8c67a49ce3df191771ff88013";

const _DADATA_COUNTRY = {
  default: "",
  [LITVA]: "Литва"
};
export const DADATA_COUNTRY = region.getRegionConfig(_DADATA_COUNTRY);

// _DADATA_REGION[SVERD] = '92b30014-4d52-4e2e-892d-928142b924bf'
const _DADATA_REGION = {
  default: "",
  [KALUG]: "18133adf-90c2-438e-88c4-62c41656de70"
};
export const DADATA_REGION = region.getRegionConfig(_DADATA_REGION);

export const DADATA_FULL_DISTRICT = region.getRegionConfig({
  default: "Вся область",
  [KALUG]: "Калужская обл"
});

export const NOMINATIM_COUNTRY_CODES = region.getRegionConfig({
  default: "",
  [LITVA]: "lt"
});

export const FIAS_DISTRICTS_PARENT_GUID = region.getRegionConfig({
  default: "",
  [KALUG]: "18133adf-90c2-438e-88c4-62c41656de70"
});

export const NOMINATIM_API_URL = region.getRegionConfig({
  default: "https://nominatim.openstreetmap.org/"
});

// see avalaibled providers in src/components/address/address.vue
export const DEFAULT_ADDRESS_PROVIDER = (function() {
  let storageValue = window.localStorage.getItem("DEFAULT_ADDRESS_PROVIDER") ? JSON.parse(window.localStorage.getItem("DEFAULT_ADDRESS_PROVIDER")) : null;
  if (storageValue) {
    return storageValue;
  }

  return region.getRegionConfig({
    default: "dadata",
    [LITVA]: "nominatim",
    [KALUG]: "tree" // 'custom'
  });
}());

export const Neutralization = "neutralization";
export const NeutralizationId = 3;
export const Utilization = "utilization";
export const UtilizationId = 5;
export const Processing = "processing";
export const ProcessingId = 2;
export const ProcessingNoTko = "processing_notko";
export const ProcessingNoTkoId = 8;
export const Formed = "formed";
export const Located = "located";
export const Burial = "burial";
export const BurialId = 6;
export const Consumption = 'consumption';
export const ConsumptionId = 11;
export const Accommodation = 'accommodation';
export const AccommodationId = 12;
export const Storage = "storage";
export const StorageId = 4;
export const TransportationId = 1;
export const Transportation = "transportation";
export const CollectingId = 7;
export const Ossig = "ossig";
export const OssigId = 9;
export const ProductionConsumption = "production_consumption";
export const ProductionConsumptionId = 10;
export const Collecting = "collecting";

export const WasteGenerators = "waste-generators";
export const Regions = "regions";

const _ACTIONS_ALL = {
  collection: {
    label: "Сбор",
    value: "collection",
    tko_action_id: 7
  },
  transportation: {
    label: "Транспортирование ",
    value: "transportation",
    tko_action_id: TransportationId
  },
  processing: {
    label: "Обработка",
    value: Processing,
    tko_action_id: ProcessingId
  },
  utilization: {
    label: "Утилизация",
    value: Utilization,
    tko_action_id: UtilizationId
  },
  neutralization: {
    label: "Обезвреживание",
    value: Neutralization,
    tko_action_id: NeutralizationId
  },
  storage: {
    label: "Хранение",
    value: Storage,
    tko_action_id: StorageId
  },
  burial: {
    label: "Захоронение",
    value: Burial,
    tko_action_id: BurialId
  }
};


const _ACTIONS_FOR_KURSK = {
  collection: {
    label: "Сбор",
    value: "collection",
    tko_action_id: 7
  },
  transportation: {
    label: "Транспортирование ",
    value: "transportation",
    tko_action_id: TransportationId
  },
  processing: {
    label: "Обработка ТКО",
    value: Processing,
    tko_action_id: ProcessingId
  },
  processing_notko: {
    label: "Обработка не ТКО",
    value: ProcessingNoTko,
    tko_action_id: ProcessingNoTkoId
  },
  utilization: {
    label: "Утилизация",
    value: Utilization,
    tko_action_id: UtilizationId
  },
  neutralization: {
    label: "Обезвреживание",
    value: Neutralization,
    tko_action_id: NeutralizationId
  },
  storage: {
    label: "Хранение",
    value: Storage,
    tko_action_id: StorageId
  },
  burial: {
    label: "Захоронение",
    value: Burial,
    tko_action_id: BurialId
  }
};
// https://redmine.etton.ru/issues/14817

const _ACTIONS_WITH_RELOAD = {
  collection: {
    label: "Сбор",
    value: Collecting,
    tko_action_id: CollectingId
  },
  processing: {
    label: "Обработка",
    value: Processing,
    tko_action_id: ProcessingId
  },
  utilization: {
    label: "Утилизация",
    value: Utilization,
    tko_action_id: UtilizationId
  },
  neutralization: {
    label: "Обезвреживание",
    value: Neutralization,
    tko_action_id: NeutralizationId
  },
  storage: {
    label: "Размещение",
    value: Storage,
    tko_action_id: StorageId
  },
  transportation: {
    label: "Транспортирование",
    value: Transportation,
    tko_action_id: TransportationId
  }
};

export const ACTIONS_FOR_ATU = {
  utilization: {
    label: "Утилизация",
    value: Utilization,
    tko_action_id: UtilizationId
  },
  storage: {
    label: "Размещение",
    value: Storage,
    tko_action_id: StorageId
  },
  processing: {
    label: "Обработка",
    value: Processing,
    tko_action_id: ProcessingId
  },
  neutralization: {
    label: "Обезвреживание",
    value: Neutralization,
    tko_action_id: NeutralizationId
  }
};

const _ACTIONS_FOR_KAMCHATKA = {
  collection: {
    label: "Сбор",
    value: "collection",
    tko_action_id: 7
  },
  transportation: {
    label: "Транспортирование ",
    value: "transportation",
    tko_action_id: TransportationId
  },
  processing: {
    label: "Обработка",
    value: Processing,
    tko_action_id: ProcessingId
  },
  utilization: {
    label: "Утилизация",
    value: Utilization,
    tko_action_id: UtilizationId
  },
  neutralization: {
    label: "Обезвреживание",
    value: Neutralization,
    tko_action_id: NeutralizationId
  },
  storage: {
    label: "Хранение",
    value: Storage,
    tko_action_id: StorageId
  },
  burial: {
    label: "Захоронение",
    value: Burial,
    tko_action_id: BurialId
  },
  ossig: {
    label: "ОССиГ",
    value: Ossig,
    tko_action_id: OssigId
  }
};

const _ACTIONS_FOR_KRAS = {
  collection: {
    label: "Сбор",
    value: "collection",
    tko_action_id: 7
  },
  transportation: {
    label: "Транспортирование ",
    value: "transportation",
    tko_action_id: TransportationId
  },
  processing: {
    label: "Обработка",
    value: Processing,
    tko_action_id: ProcessingId
  },
  utilization: {
    label: "Утилизация",
    value: Utilization,
    tko_action_id: UtilizationId
  },
  neutralization: {
    label: "Обезвреживание",
    value: Neutralization,
    tko_action_id: NeutralizationId
  },
  storage: {
    label: "Хранение",
    value: Storage,
    tko_action_id: StorageId
  },
  burial: {
    label: "Захоронение",
    value: Burial,
    tko_action_id: BurialId
  },
  consumption: {
    label: "Потребление продуктов переработки",
    value: Consumption,
    tko_action_id: ConsumptionId
  },
  accommodation: {
    label: "Размещение",
    value: Accommodation,
    tko_action_id: AccommodationId
  }
};

export const ACTIONS = region.getRegionConfig({
  default: _ACTIONS_ALL,
  [KARELIA]: _ACTIONS_WITH_RELOAD,
  [KURSK]: _ACTIONS_FOR_KURSK,
  [KAMCHATKA]: _ACTIONS_FOR_KAMCHATKA,
  [KRASNODAR]: _ACTIONS_FOR_KRAS
});

export const TARIFFS = {
  6: {
    label: "Единый тариф на услугу Регионального оператора",
    id: 6
  },
  1: {
    label: "Тариф на обработку ТКО",
    id: 1
  },
  2: {
    label: "Тариф на обезвреживание ТКО",
    id: 2
  },
  3: {
    label: "Тариф на захоронение ТКО",
    id: 3
  },
  4: {
    label: "Цена на сбор ТКО",
    id: 4
  },
  5: {
    label: "Цена на транспортирование ТКО",
    id: 5
  }
};
export const TARIFFS_TKO_OBJECT = {
  1: {
    label: "Тариф на обработку",
    id: 1
  },
  3: {
    label: "Тариф на захоронение",
    id: 3
  },
  2: {
    label: "Тариф на обезвреживание",
    id: 2
  },
  7: {
    label: "Тариф на утилизацию",
    id: 7
  }
};

const STATUS_ACTIVE = 1;
const STATUS_NOT_ACTIVE = 2;
const STATUS_PLANED = 3;

export const STATUS = {
  ACTIVE: STATUS_ACTIVE,
  IN_ACTIVE: STATUS_NOT_ACTIVE,
  PLANED: STATUS_PLANED
};

export const SENSOR_STATUS_ACTIVE = 1;
export const SENSOR_STATUS_ALARMED = 2;
export const SENSOR_STATUS_BROKEN = 3;

export const STATUSES = [
  {
    name: "Действующий",
    id: STATUS_ACTIVE
  },
  {
    name: "Не действующий",
    id: STATUS_NOT_ACTIVE
  }
];

export { STATUS_ACTIVE, STATUS_PLANED, STATUS_NOT_ACTIVE };

export const SHOW_HTML_IN_MENU = window.localStorage.getItem("SHOW_HTML_IN_MENU") ? JSON.parse(window.localStorage.getItem("SHOW_HTML_IN_MENU")) : false;

export const SITE_NAME = region.getRegionConfig(APP_NAME);

export const CALENDAR = {
  valueFormat: "yyyy-MM-dd",
  format: "dd.MM.yyyy"
};

export const SHOW_PERMS_TIPS = window.localStorage.getItem("SHOW_PERMS_TIPS") ? JSON.parse(window.localStorage.getItem("SHOW_PERMS_TIPS")) : false;

export const SHOW_HIDDEN_FIELDS = window.localStorage.getItem("SHOW_HIDDEN_FIELDS") ? JSON.parse(window.localStorage.getItem("SHOW_HIDDEN_FIELDS")) : false;

export const FORCE_ENABLE_DISABLED_FIELDS = window.localStorage.getItem("FORCE_ENABLE_DISABLED_FIELDS") ? JSON.parse(window.localStorage.getItem("FORCE_ENABLE_DISABLED_FIELDS")) : false;

export const USE_DEV_PERMS = window.localStorage.getItem("USE_DEV_PERMS") ? JSON.parse(window.localStorage.getItem("USE_DEV_PERMS")) : false;

export const APPEAL_CATS = [
  { id: 1, name: "Несанкционированная свалка" },
  { id: 2, name: "Вывоз мусора / График вывоза" },
  { id: 3, name: "Тариф" },
  { id: 4, name: "Предложение" },
  { id: 5, name: "Прочее" }
];

export const APPEAL_CATS_WITH_ALL = [
  { id: "", name: "Все" },
  ...APPEAL_CATS
];

export const APPEAL_STATUSES = [
  { id: 1, name: "Новое" },
  { id: 2, name: "На рассмотрении" },
  { id: 3, name: "Запланировано" },
  { id: 4, name: "В работе" },
  { id: 5, name: "Заявка решена" },
  { id: 6, name: "Мотивированный отказ" }
];

export const APPEAL_STATUSES_WITH_ALL = [
  { id: "", name: "Все" },
  ...APPEAL_STATUSES
];

export const EMPLOYEE_POSITION_DRIVER = 2;
export const EMPLOYEE_POSITION_MECHANIC = 3;
export const EMPLOYEE_POSITION_RIGGER = 4;
export const EMPLOYEE_POSITION_TAXI = 5;

export const EMPLOYEE_POSITIONS = [
  { id: 1, name: "Диспетчер" },
  { id: EMPLOYEE_POSITION_DRIVER, name: "Водитель" },
  { id: EMPLOYEE_POSITION_MECHANIC, name: "Механик" },
  { id: 4, name: "Такелажник" },
  { id: 5, name: "Таксировщик" }
];

export const EMPLOYEE_POSITIONS_WITH_ALL = [
  { id: "", name: "Все" },
  ...EMPLOYEE_POSITIONS
];

export const CAR_STATUSES = [
  { id: STATUS_ACTIVE, name: "На линии" },
  { id: STATUS_NOT_ACTIVE, name: "На ремонте" },
  { id: STATUS_PLANED, name: "Недоступен" }
];

export const PERIOD_DAILY = 1;
export const PERIOD_DAY_2 = 2;
export const PERIOD_DAY_3 = 3;
export const PERIOD_WEEKLY = 4;
export const PERIOD_WEEKLY_ID = 4;
export const PERIODS = [
  { id: PERIOD_DAILY, name: "Ежедневный" },
  { id: PERIOD_DAY_2, name: "Через день" },
  { id: PERIOD_DAY_3, name: "Раз в три дня" },
  { id: PERIOD_WEEKLY, name: "День недели" }
];

export const GARBAGE_TYPE_MANAGER = 1; // управл орг
export const GARBAGE_TYPE_COUNTRY_COMM = 7; // Садовые дачные товарищества
export const GARBAGE_TYPE_SETTLEMENT = 3; // Деревни, поселки, села
export const GARBAGE_TYPE_RECREATIO_PURPOSES = 17; // Объекты рекреационного назначения
export const GARBAGE_TYPE_DEFENCE = 4;
export const GARBAGE_TYPE_GARAGE = 8;
export const GARBAGE_TYPE_INDIVIDUAL_AREA = 6;
export const GARBAGE_TYPE_INDIVIDUAL = 9;
export const GARBAGE_TYPE_LEGAL_ENTITY = 10;
export const GARBAGE_TYPE_MEDIC = 5;
export const GARBAGE_TYPE_ORGANIZATION = 2;
export const GARBAGE_TYPE_MKD = 9;
export const GARBAGE_TYPE_DEPOSITS = 10;
export const GARBAGE_TYPE_FACTORIES = 11;
export const GARBAGE_TYPE_DORMITORIES = 12;
export const GARBAGE_TYPE_PUBLIC_PLACE = 13;
export const GARBAGE_TYPE_EDUCATIONAL = 14;
export const GARBAGE_TYPE_HEALTH_RESORT = 15;
export const GARBAGE_TYPE_ANIMAL_HUSBANDRY = 16;
export const GARBAGE_TYPE_RECREATIO_PURPOSE = 17;
export const GARBAGE_TYPE_AGRICULTURAL_PURPOSE = 18;

export const NORMATIVE_TYPE_MKD = "mkd";
export const NORMATIVE_TYPE_LEGAL = "organization";
export const NORMATIVE_TYPE_INDIVIDUAL = "individual_area";

export const GARBAGE_TYPE_CODES = {
  UK: "uk",
  ORGANIZATION: "organization",
  SETTLEMENT: "settlement",
  ANIMAL_HUSBANDRY: 'animal_husbandry',
  RECREATIO_PURPOSE: 'recreatio_purpose',
  AGRICULTURAL_PURPOSE: 'agricultural_purpose',
  DEFENSE: "defense",
  MED: "med",
  INDIVIDUAL_AREA: "individual_area",
  COUNTRY_COMMUNITY: "country_community",
  GSK: "gsk",
  MKD: "mkd",
  MESTO: "mesto",
  FACTORI: "factori",
  HOSTEL: "hostel",
  PUBLIC_PLACE: "public_place",
  EDUCATIONAL: "educational",
  HEALTH_RESORT: "health_resort",
};

export const BILL_HOUSE_TYPE_MKD = "mkd";
export const BILL_HOUSE_TYPE_INDIVIDUAL = "id";

export const BILL_TYPE_MKD = 2;
export const BILL_TYPE_LEGAL = 1;
export const BILL_TYPE_INDIVIDUAL = 3;

export const ENABLE_ISOBANDS = window.localStorage.getItem("ENABLE_ISOBANDS") ? JSON.parse(window.localStorage.getItem("ENABLE_ISOBANDS")) : false;
export const ENABLE_ISOBANDS_CACHE = window.localStorage.getItem("ENABLE_ISOBANDS_CACHE") ? JSON.parse(window.localStorage.getItem("ENABLE_ISOBANDS_CACHE")) : true;
export const OBJECT_RENDERER = window.localStorage.getItem("OBJECT_RENDERER") ? JSON.parse(window.localStorage.getItem("OBJECT_RENDERER")) : "superclaster";

export const ACTION_TYPES = [
  { id: "update", name: "Отредактированные" },
  { id: "create", name: "Созданные" },
  { id: "delete", name: "Удаленные" }
];

export const LEVEL_CSS_CLASS_MAP = {
  1: "first-level",
  2: "second-level",
  3: "third-level",
  4: "fourth-level",
  5: "fifth-level",
  6: "sixth-level",
  7: "seventh-level",
  8: "eighth-level",
};

export const BANK_ACCOUNT_TYPE_LEGAL = "BANK_ACCOUNT_TYPE_LEGAL";
export const BANK_ACCOUNT_TYPE_HOUSE = "BANK_ACCOUNT_TYPE_HOUSE";
export const BANK_ACCOUNT_TYPE_MKD = "BANK_ACCOUNT_TYPE_MKD";

export const FIREBASE_CONFIG = region.getRegionConfig({
  default: {
    apiKey: "AIzaSyDGbK7ImpOFoyuhCSSCPEwUHcT1k3QVbzI",
    authDomain: "pwa-tko.firebaseapp.com",
    databaseURL: "https://pwa-tko.firebaseio.com",
    projectId: "pwa-tko",
    storageBucket: "pwa-tko.appspot.com",
    messagingSenderId: "591050392457"
  }
});

// set it to '' in production!!
export const CLOUD_SERVER_KEY = "AAAAiZ1ZQ4k:APA91bH2xWRF_Zx_NZCiGL9Op43BdZnUglGGHAqdHb_OD2QrJM2zGoTfJdPhgbaALYxLuBkK7hb8jtFW3aisxje5P3eJATrwiVmz557XMgkS8qLvfCpsGuhIqYHNAwXOThLVm5PjbVJA";

export const OPERATION_RECACL_TYPE_TARIFF = 1;
export const OPERATION_RECACL_TYPE_NORMATIVE = 2;
export const OPERATION_RECACL_TYPE_UNIT = 3;

export const OBJECT_TO_OBJECT_AVAILABLE = region.getRegionConfig({
  default: false,
  [KARELIA]: true
});

export const COLORS_AVAILABLE = region.getRegionConfig({
  default: true
});

export const UNIT_OPTIONS = [
  { id: 1, name: "Тонн" },
  { id: 2, name: "Тыс. тон" },
  { id: 3, name: "Куб. м." }
];

export const REGION_CODE = region.getRegionConfig({
  default: "",
  [BURYATIA]: 3,
  [CHECHNYA]: 20,
  [CHUVA]: 21,
  [CRIMEA]: 91,
  [KARELIA]: 10,
  [KRASNODAR]: 23,
  [KURGAN]: 45,
  [KURSK]: 46,
  [MARIEL]: 13,
  [PRIMOR]: 25,
  [PSCOV]: 60,
  [SAHALIN]: 65,
  [TATAR]: 16,
  [VOLGOGRAD]: 34,
  [YANAO]: 89,
  [LEN]: 47,
  [TAMBOV]: 68,
  [TULA]: 71,
  [KAMCHATKA]: 41,
});
